/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOutOfOrder = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5.68 7.094A7.965 7.965 0 0 0 4 12c0 1.849.627 3.551 1.68 4.906L10.586 12 5.68 7.094zM7.094 5.68 12 10.586l4.906-4.906A7.965 7.965 0 0 0 12 4a7.965 7.965 0 0 0-4.906 1.68zM18.32 7.094 13.414 12l4.906 4.906A7.965 7.965 0 0 0 20 12a7.966 7.966 0 0 0-1.68-4.906zM16.906 18.32 12 13.414 7.094 18.32A7.966 7.966 0 0 0 12 20a7.965 7.965 0 0 0 4.906-1.68zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgOutOfOrder as OutOfOrder };
